import React, { useCallback } from "react";
/* Need to build a blank cell list when user clicks CLEAR ALL */
import { buildCellList } from "../utils";

/**
 * The ActionPanel component represents the interface for updating the Grid
 * based on any number of buttons the user might click on.
 */
const ActionPanel = (props) => {
  const activeColor = props.activeColor;
  const cellList = props.cellList;
  const setCellList = props.setCellList;
  var userColor = props.userColor;
  console.log(props.GridColorList);

  const onUpdateColorList = useCallback(
    (event) => {
      props.GridColorList.push(event);
      const n = [...props.GridColorList];
      props.onUpdateColorList(n);
    },
    [props.onUpdateColorList]
  );
  /**
   * Create constants for activeColor, cellList, and setCellList, reading them from the props
   */

  return (
    <div className="action-panel">
      {/* 
      This button needs an onClick function which:
        - creates a new cell list using buildCellList
        - passes the new cell list to setCellList
        */}
      <button
        onClick={() => {
          const newCellList = buildCellList();
          setCellList(newCellList);
        }}
      >
        clear all
      </button>
      {/* 
      This button needs an onClick function which:
        - creates a new cell list using buildCellList
        - loops over it, setting the color on each cell to activeColor
        - passes the new cell list to setCellList
    */}
      <button
        onClick={() => {
          const newCellList = buildCellList();
          newCellList.forEach((cell) => {
            cell.color = activeColor;
          });
          setCellList(newCellList);
        }}
      >
        fill all
      </button>
      {/* 
      This buttonm needs an onClick function which:
        - creates a new cell list using buildCellList
        - loops over the original cellList, and for each cell in it:
          - set the corresponding (by index) new cell to its color (if it has one) OR
          - set the corresponding (by index) new cell to the activeColor
    */}
      <button
        onClick={() => {
          const newCellList = buildCellList();
          cellList.forEach((cell, index) => {
            if (cell.color === null) {
              newCellList[index].color = activeColor;
            } else {
              newCellList[index].color = cell.color;
            }
          });
          setCellList(newCellList);
        }}
      >
        fill empty
      </button>

      <button
        onClick={(event) => {
          userColor = prompt("Please enter a color");
          onUpdateColorList(userColor);
          // var x = props.Colors.push(userColor);
          // setColor(x);
        }}
      >
        New Color
      </button>
    </div>
  );
};

export default ActionPanel;
